'use strict';
/**
 * Actions call mutations which update our current state
 * Actions could execute sync or async operations.
 */

import WallboardService from '@/services/wallboardService';

const requestWallboard = ({ commit, rootGetters }, dashboardId = '') => {
  if (!dashboardId) {
    dashboardId = rootGetters['AGENT/loggedInAgent'].userId;
  }

  return WallboardService.getWallboard(dashboardId).then(response => {
    if (response.data) {
      const cards = response.data.cards;

      if (cards) {
        commit('setWallboardCards', cards);
      }

      const intervalSeconds = response.data.intervalSeconds;

      if (intervalSeconds) {
        commit('setSlidesInterval', intervalSeconds);
      }

      const fontSize = response.data.fontSize;

      if (fontSize) {
        commit('setWallboardFontSize', fontSize);
      }

      const name = response.data.name;

      if (name) {
        commit('setWallboardName', name);
      }

      const theme = response.data.theme;

      if (theme) {
        commit('setWallboardTheme', theme);
      }
    }
  });
};

const requestWallboardStats = ({ commit }) => {
  return WallboardService.getStats().then(response => {
    const stats = response.data;

    if (stats) {
      commit('setWallboardStatistics', stats);

      return stats;
    }
  });
};

const updateWallboardCards = ({ commit, rootGetters }, payload) => {
  let dashboardId = payload.dashboardId;
  if (!dashboardId) {
    dashboardId = rootGetters['AGENT/loggedInAgent'].userId;
  }

  return WallboardService.updateWallboard(dashboardId, payload).then(response => {
    const cards = response.data.cards;
    if (cards) {
      commit('setWallboardCards', cards);
      return cards;
    }
  });
};

const updateWallboard = ({ commit, rootGetters }, payload) => {
  let dashboardId = payload.dashboardId;
  if (!dashboardId) {
    dashboardId = rootGetters['AGENT/loggedInAgent'].userId;
  }

  if (payload.seconds) {
    const MIN_SECONDS = 3;

    // prevent second from being less than `MIN_SECONDS`
    if (payload.seconds < MIN_SECONDS) {
      payload.seconds = MIN_SECONDS;
    }
  }

  if (payload.fontSize) {
    const MIN_FONT_SIZE = 1;
    const MAX_FONT_SIZE = 5;

    if (payload.fontSize < MIN_FONT_SIZE) payload.fontSize = MIN_FONT_SIZE;
    else if (payload.fontSize > MAX_FONT_SIZE) payload.fontSize = MAX_FONT_SIZE;
  }

  return WallboardService.updateWallboard(dashboardId, payload).then(response => {
    const name = response.data.name;

    if (payload.name && name) {
      commit('setWallboardName', name);
    }

    const interval = response.data.intervalSeconds;

    if (payload.intervalSeconds && interval) {
      commit('setSlidesInterval', interval);
    }

    const fontSize = response.data.fontSize;

    if (payload.fontSize && fontSize) {
      commit('setWallboardFontSize', fontSize);
    }

    const cards = response.data.cards;

    if (cards) {
      commit('setWallboardCards', cards);
    }

    const theme = response.data.theme;
    if (theme) {
      commit('setWallboardTheme', theme);
    }

    return response.data;
  });
};

export default {
  requestWallboard,
  requestWallboardStats,
  updateWallboard,
  updateWallboardCards
};
